<div class="m-mat-alert  m-mat-alert--{{type}}" role="alert">
	<div class="m-mat-alert__icon">
		<i class="la la-warning"></i>
	</div>
	<div class="m-mat-alert__text">
		<ng-content></ng-content>
	</div>
	<div class="m-mat-alert__close" *ngIf="showCloseButton">
		<button type="button" 
			mat-icon-button 
			color="warn" 
			(click)="closeAlert()">
			<mat-icon class="material-icons">clear</mat-icon>
		</button>
	</div>
</div>
